import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ComponentQuestionsSettings from './ComponentQuestionsSettings.tsx';

const queryClient = new QueryClient();
export default function ComponentQuestions() {
  return (
    <QueryClientProvider client={queryClient}>
      <ComponentQuestionsSettings />
    </QueryClientProvider>
  );
}
